import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getReportsStagesProgressWithWorks: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REPORTS_STAGES_PROGRESS_WITH_WORKS].GET_REPORTS_STAGES_PROGRESS_WITH_WORKS,
	},
}
